module.exports = __webpack_public_path__ + "img/belinha_duvida.2c9b986e.png";